/// <reference types="vite-plugin-svgr/client" />
import {Layer} from '/@/types/layer';
import { v4 as uuid } from 'uuid';
import { useState } from 'react';

import EyeOpenSVG from './eye-open.svg?react';
import EyeClosedSVG from './eye-closed.svg?react';
import './layer-manager.scss';

interface SublayerInfo {
  id: string;
  thumbnail: string;
  type: 'undo' | 'redo';
  index: number;
}

interface LayerManagerProps {
  layers: Layer[];
  selectedLayerId: string;
  sublayers: SublayerInfo[];
  onAddLayer: (layerId: string) => void;
  onSelectLayer: (layerId: string) => void;
  onToggleLayerVisible: (layerId: string) => void;
  onDeleteLayer: (layerId: string) => void;
  onMoveLayerUp: (layerId: string) => void;
  onMoveLayerDown: (layerId: string) => void;
}

function LayerManager({
  layers,
  selectedLayerId,
  sublayers,
  onAddLayer,
  onSelectLayer,
  onToggleLayerVisible,
  onDeleteLayer,
  onMoveLayerUp,
  onMoveLayerDown,
}: LayerManagerProps) {
  const [sublayersCollapsed, setSublayersCollapsed] = useState(true);
  
  const handleAddLayer = () => {
    const newLayerId = uuid(); // Generate a unique identifier for the new layer
    onAddLayer(newLayerId);
  };

  const selectedLayer = layers.find(layer => layer.id === selectedLayerId);

  return (
    <div className="layer-manager">
      <div className="layer-manager__main">
        <button onClick={handleAddLayer}>+</button>
        <ul>
          {layers.map((layer) => (
            <li key={layer.id} className={`${layer.id === selectedLayerId ? 'selected-layer' : ''}`}>
              <button onClick={() => onToggleLayerVisible(layer.id)}>
                {layer.visible ? <EyeOpenSVG fill="#fff"/> : <EyeClosedSVG fill="#fff"/>}
              </button>
              <span className="layer-manager__label" onClick={() => onSelectLayer(layer.id)}>
                {layer.label}
              </span>
              <div className="layer-manager__buttons">
                <button onClick={() => onMoveLayerUp(layer.id)}>⬆</button>
                <button onClick={() => onMoveLayerDown(layer.id)}>⬇</button>
                <button disabled={layers.length <= 1} onClick={() => onDeleteLayer(layer.id)}>🗑</button>
              </div>
            </li>
          ))}
        </ul>
      </div>
      
      {selectedLayer && (
        <div className="layer-manager__sublayers">
          <div className="layer-manager__sublayers-header" onClick={() => setSublayersCollapsed(!sublayersCollapsed)}>
            <h3>Sous-calques de {selectedLayer.label}</h3>
            <span className="layer-manager__sublayers-toggle">
              {sublayersCollapsed ? '▶' : '▼'}
            </span>
          </div>
          {!sublayersCollapsed && (
            <div className="layer-manager__sublayers-list">
              {sublayers.length === 0 ? (
                <p>Aucun sous-calque</p>
              ) : (
                sublayers.map((sublayer) => (
                  <div key={sublayer.id} className={`layer-manager__sublayer layer-manager__sublayer--${sublayer.type}`}>
                    <img 
                      src={sublayer.thumbnail} 
                      alt={`Sous-calque ${sublayer.index}`}
                      className="layer-manager__sublayer-thumbnail"
                    />
                    <span className="layer-manager__sublayer-label">
                      {sublayer.type === 'undo' ? 'Annuler' : 'Rétablir'} {sublayer.index}
                    </span>
                  </div>
                ))
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export {LayerManager};
